import styled from 'styled-components';

export const DetailsButtonCell = styled.td`
  width: 36px;
  padding: 0;
  margin: 0;
  line-height: 100%;
  box-sizing: border-box;
  background: transparent;
  height: 48px;
  border: ${({ show, theme, overwriteGlobalCSS }) =>
    show && theme && `thin solid ${theme.borderColor} ${overwriteGlobalCSS ? '!important' : ''}`};

  display: ${props => (props.expand || props.selective ? 'table-cell' : 'none')};
  display: ${({ isFooter }) => isFooter && 'none'};
  @media only screen and (max-width: ${({ mobileSize }) => `${mobileSize}px` || '580px'}) {
    display: ${props =>
    (props.expand || props.selective || props.mobileColumns ? 'table-cell' : 'none')};
    display: ${({ isFooter }) => isFooter && 'none'};
  }

  @media print {
    display: none;
  }
`;
